export const SERVER_IP = `https://artwork.memorymaps.io`;
// export const SERVER_IP = `http://localhost:5000`;
export const RECAPTCHA_SITE_KEY = `6LdGlkkcAAAAADAzdAFJMmkGH7F_rhrJbs_Bwd0i`;
export const CLIENT_IP = window.location.host;